import { ApiResponse } from "@api/apiRequest";
import { tpApi } from "@api/instances";
import rollbar, { LogMetadata } from "@utils/rollbar";

const cancelZuoraAthletePremiumSubscription = async (): Promise<ApiResponse<void>> => {
  try {
    await tpApi.delete(
      "/billing/v1/subscriptions",
      { requireAuth: true }
    );
    return { data: null, success: true, error: "" };
  } catch (e) {
    const err = e instanceof Error ? e : new Error("Unknown error");
    const meta: LogMetadata = { endpoint: "/billing/v1/subscriptions", method: "DELETE" };
    rollbar.error(err, meta);
    return { data: null, success: false, error: "Error cancelling subscription" };
  }
};

export default cancelZuoraAthletePremiumSubscription;
